import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRepeat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconRepeat"><Path fillRule="evenodd" clipRule="evenodd" d="M2 3H22V19H13.6682L16.0598 21.2076L15.0424 22.3098L10.6677 18.2716L15 13.9393L16.0607 15L13.5607 17.5H20.5V4.5H3.5V17.5H8V19H2V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRepeat;
